import { format } from 'owa-localize';
import FilePickerPanelViewState from '../store/schema/FilePickerPanelViewState';
import FileProviderItemViewState, {
    FileProviderItemType,
} from '../store/schema/FileProviderItemViewState';
import {
    unsupportedAttachForAllProviders,
    itemHasExtensionOrMime,
} from './fileProviderInfo/fileProviderItemsSupportedActions';
import { shouldDisableAttachButton } from './shouldDisableActionButton';
import FilePickerActionMessageType, {
    actionMessageMap,
} from '../types/FilePickerActionMessageType';

export function getDisabledAttachTooltip(
    viewState: FilePickerPanelViewState,
    maxAllowedLocalFilesSize: number
): string | null {
    const { filePickerViewState, selectedFileProvider } = viewState;
    const items: FileProviderItemViewState[] = filePickerViewState?.selectedFileProviderItems;
    if (!items || !selectedFileProvider) {
        return null;
    }

    if (items.some(item => item.type === FileProviderItemType.Folder)) {
        return format(
            actionMessageMap[FilePickerActionMessageType.AttachFolder](),
            selectedFileProvider.name
        );
    }

    const disableAttachButtonInfo = shouldDisableAttachButton(
        items,
        selectedFileProvider.name,
        maxAllowedLocalFilesSize
    );
    if (disableAttachButtonInfo.shouldDisable) {
        return disableAttachButtonInfo.message;
    }

    let disabledTooltip: string;
    unsupportedAttachForAllProviders().forEach(unsupported => {
        if (items.some(itemHasExtensionOrMime(unsupported.extensionOrMimes))) {
            disabledTooltip = format(unsupported.message, selectedFileProvider.name);
        }
    });

    if (disabledTooltip) {
        return disabledTooltip;
    }

    if (items.some(itemHasExtensionOrMime([''], false))) {
        return format(
            actionMessageMap[FilePickerActionMessageType.AttachWithoutExtension](),
            selectedFileProvider.name
        );
    }

    return null;
}
